import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryPartStrategy } from '../advanced-search/filters/base/entities/query-part-strategy';
import { QueryPart } from '../advanced-search/filters/base/entities/query-part.class';
import { ApiQuery } from '../core/api/entities/api-query.entity';
import { ApiFragment } from '../core/records/entities/api-fragment.class';
import { FragmentId, Metadata } from '../core/records/entities/metadata/metadata.entity';
import { ZoneRestrictions } from '../core/records/helpers/restrictions/record-zone-restrictions.helper';
import { ShRecordService } from '../core/records/services/record.service';
import { defaultSortInfo } from '../overviews/generic-overview/components/display-settings-bar/entities/sort-info.entity';
import { PaginatedResults } from '../overviews/generic-overview/components/pagination/entities/paginated-results.entity';
import { PaginationInfo } from '../overviews/generic-overview/components/pagination/entities/pagination-info.entity';

@Injectable({ providedIn: 'root' })
export class RecordDetailSandbox {
    private readonly recordsService: ShRecordService = inject(ShRecordService);
    private readonly zoneRestrictions: ZoneRestrictions = inject(ZoneRestrictions);

    public getRecord(fragmentId: FragmentId, trackConsult: boolean = false): Observable<ApiFragment> {
        return this.recordsService
            .getRecord(fragmentId, { trackConsult })
            .pipe(map(partialRecord => new ApiFragment(partialRecord.metadata as Metadata)));
    }

    public getMainFragmentChildRecords(
        mainFragmentId: FragmentId,
        paginationInfo: PaginationInfo
    ): Observable<PaginatedResults<ApiFragment>> {
        const searchQuery: QueryPart[] = [
            new QueryPart({
                field: 'MainFragment',
                strategy: QueryPartStrategy.MatchAll,
                values: [mainFragmentId]
            })
        ];

        const restriction = this.zoneRestrictions.regularRecordTypesZone();
        const query: ApiQuery = new ApiQuery(searchQuery, restriction);

        return this.recordsService.getRecords(paginationInfo, defaultSortInfo, query).pipe(
            map(paginatedResults => ({
                ...paginatedResults,
                results: paginatedResults.results.map(record => new ApiFragment(record.metadata as Metadata))
            }))
        );
    }
}
